import {Selectable} from '../../../../../core/interfaces/selectable.interface';

export class VehicleAvailableKeys implements Selectable<number> {
  constructor(public readonly availableKeys: number) {
  }

  get value(): number {
    return this.availableKeys;
  };

  get displayName(): string {
    return `Kluczyk nr. ${this.availableKeys}`;
  }

  toSelectDescription(): string {
    return `Kluczyk nr. ${this.availableKeys}`;
  }

  toSelectText(): string {
    return `Kluczyk nr. ${this.availableKeys}`;
  }
}
